module.exports = __webpack_public_path__ + "img/image45.aa00934f.webp";